import React, { createContext, useState, useEffect } from "react";
import api from "../Api";

// Funzione di decodifica token
const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1];
    const decoded = atob(payload);
    const parsed = JSON.parse(decoded);
    return parsed;
  } catch (error) {
    console.error("❌ Error decoding token:", error);
    return null;
  }
};

export const UserContext = createContext({
  user: null,
  setUser: () => {}
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedUser = decodeToken(token);
      const userId = decodedUser?.id;
      if (userId) {
        api.get(`/user/${userId}`)
          .then((response) => {
            setUser(response.data);
          })
          .catch((error) => console.error("Error fetching user data:", error));
      }
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
